import { configureStore } from "@reduxjs/toolkit";
import countriesSlice from "../reducers/countries";
import countryIdSlice from "../reducers/Countriesid";

export const store = configureStore({
  reducer: { countries: countriesSlice, countryId: countryIdSlice },
});
